import './Navbar.css';
import React, {useState, useEffect, useRef} from 'react';
import Logo from '../Img/Logo_projets&finances.png';
import { ReactComponent as IconUser } from '../Img/icon-user.svg';
import { ReactComponent as IconRetro } from '../Img/icon-back-time.svg';
import { ReactComponent as IconProsp } from '../Img/icon-increase.svg';
import { ReactComponent as IconLine } from '../Img/icon-line.svg';
import { ReactComponent as IconProjects } from '../Img/icon-projects.svg';
import { ReactComponent as IconCalendar } from '../Img/icon-calendar.svg';
import { ReactComponent as IconCamembert } from '../Img/icon-camembert.svg';
import { ReactComponent as IconComments } from '../Img/icon-comments.svg';
import { ReactComponent as IconPdf } from '../Img/icon-pdf.svg';
import { ReactComponent as Parametres } from '../Img/icon-parametres.svg';
import { ReactComponent as Customers } from '../Img/icon-customers.svg';
import { ReactComponent as Bank } from '../Img/icon-bank.svg';
import { ReactComponent as IconAxesInterventions } from '../Img/icon-axes-interventions.svg';
import { checkUser, rescueHtml } from "./Tools";
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import qs from 'qs';
import ModalComments from './ModalBlocNotes';


const Navbar = () =>
{
    const today = new Date();
    const date = String(today.getDate()).padStart(2, '0') + String(today.getMonth() + 1).padStart(2, '0');
    let history = useHistory();
    const timestamp = new Date().getTime();
    const [aff, setAff] = useState(false);
    const [user, setUser] = useState({});
    const [droits, setDroits] = useState(null);
    const [profil, setProfil] = useState(false);
    const [retro, setRetro] = useState(false);
    const [fp, setFp] = useState(false);
    const [operations, setOperations] = useState(false);
    const [parametres, setParametres] = useState(false);
    const [prosp, setProsp] = useState(false);
    const [tabBord, setTabBord] = useState(false);
    const [modalComments, setModalComments] = useState(false);
    const pathname = window.location.pathname;

    const purple = '#6571FE';
    const greyChapter = '#DBDBDB';
    

    function getDroits(id_user)
    {
        var params = {
            'getDroits': true,
            'id_user': id_user
        }
        return axios.post('https://app-slfinance.fr/api/droits.php', qs.stringify(params))
        .then((res) => {
            if (res.data['status'] === 1) {
                setDroits(res.data.droits);
            }
        })
        .catch((err) => {
            console.warn(err);
            return [];
        });
    }

        
    function getUser()
    {
        const token = localStorage.getItem("session_token")
        checkUser(token)
        .then(async (res) => {
            var tmp = res
            tmp.email = rescueHtml(res.email)
            tmp.nom = rescueHtml(res.nom)
            tmp.prenom = rescueHtml(res.prenom)
            if (res.nom_organisme) {
                tmp.nom_organisme = rescueHtml(res.nom_organisme)
            }
            await setUser(tmp);
            await getDroits(tmp.id);
            await setAff(!aff);
        })
        .catch((err) => {
            console.warn(err)
        })
    }
    

    useEffect(() => {
        getUser()
    }, [])
    

    function useOutsideAlerter(ref) {
        useEffect(() => {
            /**
             * Alert if clicked on outside of element
             */
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setProfil(false);
                    setRetro(false);
                    setFp(false);
                    setOperations(false);
                    setProsp(false);
                    setTabBord(false);
                    setParametres(false);
                }
            }
            // Bind the event listener
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                // Unbind the event listener on clean up
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }


    function updateHypotheseUser(hyp)
    {
        var params = {
            'updateUser': true,
            'hypothese': hyp,
            'id': user.id
        }
        axios.post('https://app-slfinance.fr/api/connexion.php', qs.stringify(params))
        .then((e) => {
            if (e.data['status'] === 1) {
                setTimeout(() => window.location = window.location.href, 100);
            }
        })
    }

    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef);


	return (
        <div>
            <div className='shadow-md' style={{flex: 1, backgroundColor: 'white', minHeight: 72}}>

                {/* -------- Premier bandeau horizontal -------- */}
                <div style={{display: 'flex', flex: 1}}>
                    <a style={{display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: 'transparent', border: '0px'}} href="/">
                        <img style={{ height: 40 }} src={Logo} alt="Logo" />
                    </a>
                    
                    <div style={{flex: 1}}></div>

                    {(pathname.includes('fichesprojets') || pathname.includes('operations') || pathname.includes('prospective') || pathname.includes('emprunts/manuel')) && !pathname.includes('fiche_projet')?
                    <div>
                        {user.hypothese === '1'?
                        <button
                        className='shadow-md rounded-md'
                        style={{padding: 5, textAlign: 'center', borderRadius: 5, backgroundColor: greyChapter, margin: 15, border: '2px solid '+purple, color: purple}}
                        onClick={() => {}}>
                            <p>Hypothèse 1</p>
                        </button>
                        :
                        <button
                        className='shadow-md rounded-md'
                        style={{padding: 5, textAlign: 'center', borderRadius: 5, backgroundColor: greyChapter, margin: 15}}
                        onClick={() => {
                            updateHypotheseUser(1);
                        }}>
                            <p>Hypothèse 1</p>
                        </button>
                        }
                
                        {user.hypothese === '2'?
                        <button
                        className='shadow-md rounded-md'
                        style={{padding: 5, textAlign: 'center', borderRadius: 5, backgroundColor: greyChapter, margin: 15, border: '2px solid '+purple, color: purple}}
                        onClick={() => {}}>
                            <p>Hypothèse 2</p>
                        </button>
                        :
                        <button
                        className='shadow-md rounded-md'
                        style={{padding: 5, textAlign: 'center', borderRadius: 5, backgroundColor: greyChapter, margin: 15}}
                        onClick={() => {
                            updateHypotheseUser(2);
                        }}>
                            <p>Hypothèse 2</p>
                        </button>
                        }
                
                        {user.hypothese === '3'?
                        <button
                        className='shadow-md rounded-md'
                        style={{padding: 5, textAlign: 'center', borderRadius: 5, backgroundColor: greyChapter, margin: 15, border: '2px solid '+purple, color: purple}}
                        onClick={() => {}}>
                            <p>Hypothèse 3</p>
                        </button>
                        :
                        <button
                        className='shadow-md rounded-md'
                        style={{padding: 5, textAlign: 'center', borderRadius: 5, backgroundColor: greyChapter, margin: 15}}
                        onClick={() => {
                            updateHypotheseUser(3);
                        }}>
                            <p>Hypothèse 3</p>
                        </button>
                        }
                    </div>
                    :null}

                    <div style={{flex: 1, textAlign: 'right'}}>
                        {user.nom_organisme?
                        <div style={{margin: 25}}>
                            <a href={"/organismepage?timestamp="+timestamp}>
                                <p style={{color: purple, fontWeight: 'bold', fontSize: 18}}>
                                    {date === '0104'?'🐟':date === '3110'?'🎃':(date === '2012' || date === '2112' || date === '2212' || date === '2312' || date === '2412' || date === '2512')?'🎄':''}
                                    {user.nom_organisme.toUpperCase()}
                                    {date === '0104'?'🐟':date === '3110'?'🎃':(date === '2012' || date === '2112' || date === '2212' || date === '2312' || date === '2412' || date === '2512')?'🎄':''}</p>
                                <p style={{color: 'grey', fontSize: 14}}>{user.nom_budget}  {user.email==='victor.castera@strategies-locales.fr'?' - '+user.id_budget:null}</p>
                            </a>
                        </div>
                        :null}
                    </div>

                    {/* Bouton Droits */}
                    {user.id_type_users === '1' || user.id_type_users === '2' ?
                    <button
                    style={{marginRight: 20}}
                    onClick={() => {
                        history.push('/utilisateurs?timestamp=' + timestamp);
                    }}>
                        <img src={require('../Img/icon-rules.png')} alt="Notifications" width="40" />
                    </button>
                    :null}

                    {/* Bouton Profil ou Connexion */}
                    {user.email ?
                    <button
                    style={{marginRight: 20}}
                    onClick={() => {
                        setProfil(!profil)
                    }}>
                        <IconUser width="28" />
                    </button>
                    :null}

                </div>
                
                {/********************** Modal Profil **********************/}
                {profil?
                <div ref={wrapperRef} className='shadow-xl' style={{position: 'absolute', right: 10, backgroundColor: 'white', borderRadius: 5, padding: 25, zIndex: 1000, border: '2px solid #E7E7E7', textAlign: 'center'}}>
                    
                    {(user.nom || user.prenom) ?
                    <p style={{color: purple, fontWeight: 'bold'}}>{rescueHtml(user.nom)} {rescueHtml(user.prenom)}</p>
                    :null}

                    <div style={{marginTop: 20}}>
                        <a href={"/moncompte?timestamp="+timestamp}>
                            <p style={{color: 'black'}}>Mon Profil</p>
                        </a>
                    </div>
                    <div style={{marginTop: 20}}>
                        <button onClick={() => {history.push('/logout?timestamp=' + timestamp)}}>
                            <p>Déconnexion</p>
                        </button>
                    </div>
                </div>
                :null}
            </div>
            
            
            
            {/* -------- Deuxième bandeau horizontal -------- */}
            {user.email?
            <div className='shadow-md' style={{flex: 1, backgroundColor: 'white', marginTop: 0.5, display: 'flex', minHeight: 65}}>

                {/* Bouton Retrospective */}
                {droits && (droits.retro_saisie || droits.retro_restitution || droits.retro_saisie_fiscalite || droits.retro_saisie_dette || droits.retro_verif) && 
                    <button
                    style={{marginLeft: 20, display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                    onClick={() => {
                        setRetro(!retro);
                    }}
                    >
                        <IconRetro width="20px" />
                        <p style={{flex: 1, marginLeft: 10}}>Rétrospective</p>
                    </button>
                }

                {/* Bouton Fiches projets / Opérations */}
                    {droits && (droits.fp_pilotage || droits.fp_rapport || droits.fp_synthese_globale) && 
                    <button
                    style={{marginLeft: 20, display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                    onClick={() => {
                        if (user.id_organisme_type != '4') {
                            setFp(!fp);
                        }
                        else if (user.id_organisme_type == '4') {
                            setOperations(!operations);
                        }
                    }}
                    >
                        <IconProjects width="20px" />
                        <p style={{flex: 1, marginLeft: 10}}>{user.id_organisme_type == '4'?'Opérations':'Pilotage projets'}</p>
                    </button>
                }

                {/* Bouton Prospective */}
                {droits && (droits.prosp_saisie || droits.prosp_saisie_fiscalite || droits.prosp_saisie_commentaire
                || droits.prosp_restitution || droits.prosp_saisie_emprunt_manuel || droits.prosp_saisie_emprunt_auto) && 
                    <button
                    style={{marginLeft: 20, display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                    onClick={() => {
                        setProsp(!prosp);
                    }}
                    >
                        <IconProsp width="20px" />
                        <p style={{flex: 1, marginLeft: 10}}>Prospective</p>
                    </button>
                }

                {/* Bouton Tableau de bord */}
                {droits && (droits.tdb_saisie || droits.tdb_rapport) && 
                    <button
                    style={{marginLeft: 20, display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                    onClick={() => {
                        setTabBord(!tabBord);
                    }}
                    >
                        <IconCalendar width="20px" />
                        <p style={{flex: 1, marginLeft: 10}}>TdB mensuel</p>
                    </button>
                }

                {/* Bouton Liste des Graphiques */}
                {droits && (droits.graphiques) && 
                    <button
                    style={{marginLeft: 20, display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                    onClick={() => {
                        window.location = window.location.origin + '/graphiques?timestamp='+timestamp
                    }}
                    >
                        <IconCamembert width="20px" />
                        <p style={{flex: 1, marginLeft: 10}}>Graphiques</p>
                    </button>
                }


                {/* Bouton Édition du rapport */}
                {droits && (droits.rapport_financier) && 
                    <button
                    style={{marginLeft: 20, display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                    onClick={() => {
                        window.location = window.location.origin + '/rapport/financier?timestamp='+timestamp
                    }}
                    >
                        <IconPdf width="20px" />
                        <p style={{flex: 1, marginLeft: 10}}>Rapport financier</p>
                    </button>
                }

                <div style={{flex: 1}}></div>


                {/* Bouton des bloc-notes */}
                {!modalComments && (
                pathname.includes('saisie/retrospective/fct/recette') ||
                pathname.includes('saisie/retrospective/fct/depense') ||
                pathname.includes('saisie/retrospective/inv/recette') ||
                pathname.includes('saisie/retrospective/inv/depense') ||
                pathname.includes('saisie/retrospective/fiscalite') ||
                pathname.includes('saisie/dette') ||

                pathname.includes('saisie/prospective/fct/recette') ||
                pathname.includes('saisie/prospective/fct/depense') ||
                pathname.includes('saisie/prospective/fiscalite') ||
                
                pathname.includes('emprunts/manuel') ||
                pathname.includes('emprunts/auto') ||
                
                pathname.includes('tableaudebord') ||
                pathname.includes('graphtableaudebord') ||
                
                pathname.includes('organismepage')) && (
                <button
                style={{marginRight: 20, display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                onClick={() => {
                    setModalComments(true);
                }}
                >
                    <IconComments width="15px" />
                    <p style={{flex: 1, marginLeft: 10, fontSize: 12}}>Bloc-notes</p>
                </button>
                )}

                
                {/* Bouton Paramètres */}
                {user && user.id_organisme_type == '4' && (user.id_type_users == '1'  || user.id_type_users == '2') && 
                    <button
                    style={{marginRight: 20, display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                    onClick={() => {
                        setParametres(!parametres);
                    }}
                    >
                        <Parametres width="20px" />
                        <p style={{flex: 1, marginLeft: 10, fontSize: 12}}>Paramètres</p>
                    </button>
                }
                

            </div>
            :null}

            
            {/********************** Modal Commentaires **********************/}
            {modalComments && (
                <ModalComments user={user} modalVisible={modalComments} setModalVisible={setModalComments} />
            )}



            {/********************** Modal Retrospective **********************/}
            {retro?
            <div
            ref={wrapperRef}
            className='shadow-xl'
            style={{position: 'absolute', left: 5, backgroundColor: 'white', borderRadius: 5, padding: 25, zIndex: 1000, border: '2px solid #E7E7E7', display: 'flex'}}
            >
                {droits && (droits.retro_saisie || droits.retro_saisie_fiscalite || droits.retro_saisie_dette || droits.retro_verif) &&
                    <div>
                        <div style={{display: 'flex', textAlign: 'center'}}>
                            <div style={{flex: 1}}>
                                <p style={{fontWeight: 'bold'}}>Saisie :</p>
                            </div>
                        </div>

                        {droits && (droits.retro_saisie) && 
                            <div>
                                <div style={{display: 'flex', textAlign: 'center'}}>
                                    <div style={{flex: 1, marginTop: 20, marginLeft: 'auto'}}>
                                        <p>{user && user.id_organisme_type === '4'?'Exploitation':'Fonctionnement'}</p>
                                    </div>
                                </div>

                                <div style={{marginTop: 20, display: 'flex', textAlign: 'center'}}>
                                    <a href={"/saisie/retrospective/fct/recette?timestamp="+timestamp}>
                                        <p style={{color: purple}}>Recettes</p>
                                    </a>
                                    <p style={{marginLeft: 5}}> \ </p>
                                    <a style={{marginLeft: 5}} href={"/saisie/retrospective/fct/depense?timestamp="+timestamp}>
                                        <p style={{color: purple}}>Dépenses</p>
                                    </a>
                                </div>

                                <div style={{marginLeft: 5, display: 'flex'}}>
                                    <div style={{flex: 1}}></div>
                                    <IconLine width="50px" />
                                    <div style={{flex: 1}}></div>
                                </div>

                                <div style={{marginTop: 0, textAlign: 'center'}}>
                                    <p>Investissement</p>
                                </div>

                                <div style={{marginTop: 20, display: 'flex', textAlign: 'center'}}>
                                    <a href={"/saisie/retrospective/inv/recette?timestamp="+timestamp}>
                                        <p style={{color: purple}}>Recettes</p>
                                    </a>
                                    <p style={{marginLeft: 5}}> \ </p>
                                    <a style={{marginLeft: 5}} href={"/saisie/retrospective/inv/depense?timestamp="+timestamp}>
                                        <p style={{color: purple}}>Dépenses</p>
                                    </a>
                                </div>

                            </div>
                        }
                        
                        {droits && (droits.retro_saisie_fiscalite) && user.id_organisme_type != '4' &&
                            <div>
                                <div style={{marginLeft: 5, display: 'flex'}}>
                                    <div style={{flex: 1}}></div>
                                    <IconLine width="50px" />
                                    <div style={{flex: 1}}></div>
                                </div>
                                {user.budget_annexe == 0?
                                <div style={{marginTop: 0, textAlign: 'center'}}>
                                    <a href={"/saisie/retrospective/fiscalite?timestamp="+timestamp}>
                                        <p style={{color: purple}}>Fiscalité</p>
                                    </a>
                                </div>
                                :null}
                            </div>
                        }

                        {droits && (droits.retro_saisie_dette) &&
                            <div>
                                {user.budget_annexe == 0?
                                <div style={{marginLeft: 5, display: 'flex'}}>
                                    <div style={{flex: 1}}></div>
                                    <IconLine width="50px" />
                                    <div style={{flex: 1}}></div>
                                </div>
                                :null}

                                <div style={{marginTop: 0, textAlign: 'center'}}>
                                    <a href={"/saisie/dette?timestamp="+timestamp}>
                                        <p style={{color: purple}}>Dette</p>
                                    </a>
                                </div>
                            </div>
                        }

                        {droits && (droits.retro_verif) &&
                            <div>
                                <div style={{marginLeft: 5, display: 'flex'}}>
                                    <div style={{flex: 1}}></div>
                                    <IconLine width="50px" />
                                    <div style={{flex: 1}}></div>
                                </div>

                                <div style={{marginTop: 0, textAlign: 'center'}}>
                                    <a href={"/verification/retrospective?timestamp="+timestamp}>
                                        <p style={{color: purple}}>Vérification</p>
                                    </a>
                                </div>
                            </div>
                        }
                    </div>
                }

                {droits && (droits.retro_restitution) &&
                    <div style={droits && (droits.retro_saisie || droits.retro_saisie_fiscalite || droits.retro_saisie_dette || droits.retro_verif)?{paddingLeft: 25, marginLeft: 25, borderLeft: '1px solid black'}:{}}>
                        <div style={{display: 'flex', textAlign: 'center'}}>
                            <div style={{flex: 1}}>
                                <p style={{fontWeight: 'bold'}}>Restitution :</p>
                            </div>
                        </div>

                        <div style={{display: 'flex', textAlign: 'center'}}>
                            <div style={{flex: 1, marginTop: 20, marginLeft: 'auto'}}>
                                <a href={"/restitution/retrospective/fct?timestamp="+timestamp}>
                                    <p style={{color: purple}}>{user && user.id_organisme_type === '4'?'Exploitation':'Fonctionnement'}</p>
                                </a>
                            </div>
                        </div>

                        <div style={{marginLeft: 5, display: 'flex'}}>
                            <div style={{flex: 1}}></div>
                            <IconLine width="50px" />
                            <div style={{flex: 1}}></div>
                        </div>

                        <div style={{display: 'flex', textAlign: 'center'}}>
                            <div style={{flex: 1, marginLeft: 'auto'}}>
                                <a href={"/restitution/retrospective/inv?timestamp="+timestamp}>
                                    <p style={{color: purple}}>Investissement</p>
                                </a>
                            </div>
                        </div>

                        {user.budget_annexe == 0 && user.id_organisme_type != '4' &&
                        <div style={{marginLeft: 5, display: 'flex'}}>
                            <div style={{flex: 1}}></div>
                            <IconLine width="50px" />
                            <div style={{flex: 1}}></div>
                        </div>
                        }

                        {user.budget_annexe == 0 && user.id_organisme_type != '4' &&
                        <div style={{display: 'flex', textAlign: 'center'}}>
                            <div style={{flex: 1, marginLeft: 'auto'}}>
                                <a href={"/restitution/retrospective/fiscalite?timestamp="+timestamp}>
                                    <p style={{color: purple}}>Fiscalité</p>
                                </a>
                            </div>
                        </div>
                        }
                        
                    </div>
                }
            </div>
            :null}

            {/********************** Modal Fiches projets **********************/}
            {fp?
            <div
            ref={wrapperRef}
            className='shadow-xl'
            style={{position: 'absolute', left: 170, backgroundColor: 'white', borderRadius: 5, padding: 25, zIndex: 1000, border: '2px solid #E7E7E7', display: 'flex'}}
            >
                {droits && (droits.fp_pilotage) &&
                    <div>
                        <div style={{display: 'flex', textAlign: 'center'}}>
                            <div style={{flex: 1}}>
                                <p style={{fontWeight: 'bold'}}>Saisie :</p>
                            </div>
                        </div>

                        <div style={{display: 'flex', textAlign: 'center'}}>
                            <div style={{flex: 1, marginTop: 20, marginLeft: 'auto'}}>
                                <a href={"/fichesprojets?timestamp="+timestamp}>
                                    <p style={{color: purple}}>Pilotage des projets</p>
                                </a>
                            </div>
                        </div>
                    </div>
                }

                {droits && (droits.fp_rapport || droits.fp_synthese_globale) &&
                    <div style={droits && (droits.fp_pilotage)?{paddingLeft: 25, marginLeft: 25, borderLeft: '1px solid black'}:{}}>
                        {droits && (droits.fp_rapport || droits.fp_synthese_globale) &&
                            <div style={{display: 'flex', textAlign: 'center'}}>
                                <div style={{flex: 1}}>
                                    <p style={{fontWeight: 'bold'}}>Rapports :</p>
                                </div>
                            </div>
                        }

                        {droits && (droits.fp_rapport) &&
                            <div style={{display: 'flex', textAlign: 'center'}}>
                                <div style={{flex: 1, marginTop: 20, marginLeft: 'auto'}}>
                                    <a href={"/fichesprojets/listing?timestamp="+timestamp}>
                                        <p style={{color: purple}}>Fiches projets</p>
                                    </a>
                                </div>
                            </div>
                        }

                        {droits && (droits.fp_synthese_globale) &&
                            <div style={{display: 'flex', textAlign: 'center'}}>
                                <div style={{flex: 1, marginTop: 20, marginLeft: 'auto'}}>
                                    <a href={"/rapport/synthese/projets?timestamp="+timestamp}>
                                        <p style={{color: purple}}>Synthèse globale</p>
                                    </a>
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
            :null}

            {/********************** Modal Opérations **********************/}
            {operations?
            <div
            ref={wrapperRef}
            className='shadow-xl'
            style={{position: 'absolute', left: 170, backgroundColor: 'white', borderRadius: 5, padding: 25, zIndex: 1000, border: '2px solid #E7E7E7', display: 'flex'}}
            >
                {droits && (droits.fp_pilotage) &&
                    <div>
                        <div style={{display: 'flex', textAlign: 'center'}}>
                            <div style={{flex: 1}}>
                                <p style={{fontWeight: 'bold'}}>Saisie :</p>
                            </div>
                        </div>

                        <div style={{display: 'flex', textAlign: 'center'}}>
                            <div style={{flex: 1, marginTop: 20, marginLeft: 'auto'}}>
                                <a href={"/operations?timestamp="+timestamp}>
                                    <p style={{color: purple}}>Pilotage des opérations</p>
                                </a>
                            </div>
                        </div>
                    </div>
                }

                {droits && (droits.fp_rapport || droits.fp_synthese_globale) &&
                    <div style={droits && (droits.fp_pilotage)?{paddingLeft: 25, marginLeft: 25, borderLeft: '1px solid black'}:{}}>
                        {droits && (droits.fp_rapport || droits.fp_synthese_globale) &&
                            <div style={{display: 'flex', textAlign: 'center'}}>
                                <div style={{flex: 1}}>
                                    <p style={{fontWeight: 'bold'}}>Rapports :</p>
                                </div>
                            </div>
                        }

                        {droits && (droits.fp_rapport) &&
                            <div style={{display: 'flex', textAlign: 'center'}}>
                                <div style={{flex: 1, marginTop: 20, marginLeft: 'auto'}}>
                                    <a href={"/operations/listing?timestamp="+timestamp}>
                                        <p style={{color: purple}}>Opérations</p>
                                    </a>
                                </div>
                            </div>
                        }

                        {droits && (droits.fp_synthese_globale) &&
                            <div style={{display: 'flex', textAlign: 'center'}}>
                                <div style={{flex: 1, marginTop: 20, marginLeft: 'auto'}}>
                                    <a href={"/rapport/synthese/operations?timestamp="+timestamp}>
                                        <p style={{color: purple}}>Synthèse globale</p>
                                    </a>
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
            :null}

            {/********************** Modal Prospective **********************/}
            {prosp?
            <div ref={wrapperRef} className='shadow-xl' style={{position: 'absolute', left: 315, backgroundColor: 'white', borderRadius: 5, padding: 25, zIndex: 1000, border: '2px solid #E7E7E7', display: 'flex'}}>
                {droits && (droits.prosp_saisie || droits.prosp_saisie_fiscalite || droits.prosp_saisie_commentaire) &&
                    <div>
                        <div style={{textAlign: 'center'}}>
                            <p style={{fontWeight: 'bold'}}>Saisie :</p>
                        </div>

                        {droits && (droits.prosp_saisie) &&
                            <div>
                                <div style={{marginTop: 20, textAlign: 'center'}}>
                                    <p>{user && user.id_organisme_type === '4'?'Exploitation':'Fonctionnement'}</p>
                                </div>

                                <div style={{marginTop: 20, display: 'flex', textAlign: 'center'}}>
                                    <a href={"/saisie/prospective/fct/recette?timestamp="+timestamp}>
                                        <p style={{color: purple}}>Recettes</p>
                                    </a>
                                    <p style={{marginLeft: 5}}> \ </p>
                                    <a style={{marginLeft: 5}} href={"/saisie/prospective/fct/depense?timestamp="+timestamp}>
                                        <p style={{color: purple}}>Dépenses</p>
                                    </a>
                                </div>
                            </div>
                        }

                        {droits && (droits.prosp_saisie_fiscalite) && user.id_organisme_type != '4' &&
                            <div>
                                <div style={{marginLeft: 5, display: 'flex'}}>
                                    <div style={{flex: 1}}></div>
                                    <IconLine width="50px" />
                                    <div style={{flex: 1}}></div>
                                </div>

                                {user.budget_annexe == 0?
                                <div style={{marginTop: 0, textAlign: 'center'}}>
                                    <a href={"/saisie/prospective/fiscalite?timestamp="+timestamp}>
                                        <p style={{color: purple}}>Fiscalité</p>
                                    </a>
                                </div>
                                :null}
                            </div>
                        }

                        {droits && (droits.prosp_saisie_commentaire) &&
                            <div>
                                {user.budget_annexe == 0?
                                <div style={{marginLeft: 5, display: 'flex'}}>
                                    <div style={{flex: 1}}></div>
                                    <IconLine width="50px" />
                                    <div style={{flex: 1}}></div>
                                </div>
                                :null}

                                <div style={{marginTop: 0, textAlign: 'center'}}>
                                    <a href={"/saisie/prospective/commentaire?timestamp="+timestamp}>
                                        <p style={{color: purple}}>Commentaires</p>
                                    </a>
                                </div>
                            </div>
                        }
                    </div>
                }

                {droits && (droits.prosp_restitution) &&
                    <div style={droits && (droits.prosp_saisie || droits.prosp_saisie_fiscalite || droits.prosp_saisie_commentaire)?{paddingLeft: 25, marginLeft: 25, borderLeft: '1px solid black'}:{}}>
                        <div style={{display: 'flex', textAlign: 'center'}}>
                            <div style={{flex: 1}}>
                                <p style={{fontWeight: 'bold'}}>Restitution :</p>
                            </div>
                        </div>

                        <div style={{display: 'flex', textAlign: 'center'}}>
                            <div style={{flex: 1, marginTop: 20, marginLeft: 'auto'}}>
                                <a href={"/restitution/prospective/fct?timestamp="+timestamp}>
                                    <p style={{color: purple}}>{user && user.id_organisme_type === '4'?'Exploitation':'Fonctionnement'}</p>
                                </a>
                            </div>
                        </div>

                        <div style={{marginLeft: 5, display: 'flex'}}>
                            <div style={{flex: 1}}></div>
                            <IconLine width="50px" />
                            <div style={{flex: 1}}></div>
                        </div>

                        <div style={{display: 'flex', textAlign: 'center'}}>
                            <div style={{flex: 1, marginLeft: 'auto'}}>
                                <a href={"/restitution/prospective/inv?timestamp="+timestamp}>
                                    <p style={{color: purple}}>Investissement</p>
                                </a>
                            </div>
                        </div>
                    </div>
                }

                {droits && (droits.prosp_saisie_emprunt_manuel || droits.prosp_saisie_emprunt_auto) &&
                    <div style={droits && (droits.prosp_saisie || droits.prosp_saisie_fiscalite || droits.prosp_saisie_commentaire || droits.prosp_restitution)?{paddingLeft: 25, marginLeft: 25, borderLeft: '1px solid black'}:{}}>
                        <div style={{display: 'flex', textAlign: 'center'}}>
                            <div style={{flex: 1}}>
                                <p style={{fontWeight: 'bold'}}>Outils de saisie rapide :</p>
                            </div>
                        </div>

                        {droits && (droits.prosp_saisie_emprunt_manuel) &&
                            <div style={{display: 'flex', textAlign: 'center'}}>
                                <div style={{flex: 1, marginTop: 20, marginLeft: 'auto'}}>
                                    <a href={"/emprunts/manuel?timestamp="+timestamp}>
                                        <p style={{color: purple}}>Saisie des emprunts</p>
                                        <p style={{color: purple}}> futurs</p>
                                    </a>
                                </div>
                            </div>
                        }

                        {droits && (droits.prosp_saisie_emprunt_auto) &&
                            <div style={{display: 'flex', textAlign: 'center'}}>
                                <div style={{flex: 1, marginTop: 20, marginLeft: 'auto'}}>
                                    <a href={"/emprunts/auto?timestamp="+timestamp}>
                                        <p style={{color: purple}}>Calcul automatique</p>
                                        <p style={{color: purple}}>des emprunts d'équilibre</p>
                                    </a>
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
            :null}


            {/********************** Modal Tableau de bord **********************/}
            {tabBord?
            <div ref={wrapperRef}
            className='shadow-xl'
            style={{position: 'absolute', left: 470, backgroundColor: 'white', borderRadius: 5, padding: 25, zIndex: 1000, border: '2px solid #E7E7E7', display: 'flex'}}
            >
                <div>
                    <div style={{textAlign: 'center'}}>
                        <p style={{fontWeight: 'bold'}}>Tableau de bord :</p>
                    </div>

                    {droits && (droits.tdb_saisie) &&
                        <div style={{marginTop: 20, display: 'flex', textAlign: 'center'}}>
                            <a style={{flex: 1, marginLeft: 5}} href={"/tableaudebord?timestamp="+timestamp}>
                                <p style={{color: purple}}>Grille de saisie</p>
                            </a>
                        </div>
                    }

                    {droits && droits.tdb_rapport && droits.tdb_saisie &&
                       <div style={{marginLeft: 5, display: 'flex'}}>
                            <div style={{flex: 1}}></div>
                            <IconLine width="50px" />
                            <div style={{flex: 1}}></div>
                        </div>
                    }

                    {droits && droits.tdb_rapport &&
                        <div style={droits && (droits.tdb_rapport)?{marginTop: 0, textAlign: 'center'}:{marginTop: 20, textAlign: 'center'}}>
                            <a style={{flex: 1}} href={"/graphtableaudebord?timestamp="+timestamp}>
                                <p style={{color: purple}}>Édition du tableau</p>
                                <p style={{color: purple}}> de bord mensuel</p>
                            </a>
                        </div>
                    }
                </div>
            </div>
            :null}


            {/********************** Modal Paramètres **********************/}
            {parametres?
            <div
            ref={wrapperRef}
            className='shadow-xl'
            style={{position: 'absolute', right: 0, backgroundColor: 'white', borderRadius: 5, padding: 25, zIndex: 1000, border: '2px solid #E7E7E7', display: 'flex'}}
            >
                <div style={{}}>
                    <div style={{display: 'flex', textAlign: 'center'}}>
                        <div style={{flex: 1}}>
                            <p style={{fontWeight: 'bold'}}>Gestion :</p>
                        </div>
                    </div>

                    <div style={{display: 'flex', textAlign: 'center'}}>
                        <div style={{flex: 1, marginTop: 20, marginLeft: 'auto'}}>
                            <a href={"/Gestion/ModalitesPortage?timestamp="+timestamp} style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                <Bank width="20px" />
                                <p style={{color: purple, marginLeft: 5}}>Modalités de portage</p>
                            </a>
                        </div>
                    </div>

                    <div style={{marginLeft: 5, display: 'flex'}}>
                        <div style={{flex: 1}}></div>
                        <IconLine width="50px" />
                        <div style={{flex: 1}}></div>
                    </div>

                    <div style={{display: 'flex', textAlign: 'center'}}>
                        <div style={{flex: 1, marginLeft: 'auto'}}>
                            <a href={"/Gestion/AxesInterventions?timestamp="+timestamp} style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                <IconAxesInterventions width="20px" />
                                <p style={{color: purple, marginLeft: 5}}>Axes d'interventions</p>
                            </a>
                        </div>
                    </div>

                    <div style={{marginLeft: 5, display: 'flex'}}>
                        <div style={{flex: 1}}></div>
                        <IconLine width="50px" />
                        <div style={{flex: 1}}></div>
                    </div>

                    <div style={{display: 'flex', textAlign: 'center'}}>
                        <div style={{flex: 1, marginLeft: 'auto'}}>
                            <a href={"/gestion/clients?timestamp="+timestamp} style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                <Customers width="20px" />
                                <p style={{color: purple, marginLeft: 10}}>Gestion des collectivités</p>
                            </a>
                        </div>
                    </div>
                    
                </div>
            </div>
            :null}

        </div>
	);
}

export default Navbar;
